<template>
    <div class="page_column">
        <div class="container d-flex">
            <a href="/global/news/" class="page_column_part d-none d-md-flex flex-column">
                <div class="mt-auto news_area_bottom">
                    <p class="news_button"><span class="back"><a href="/global/news/">Back to all news</a></span></p>
                </div>
            </a>
            <a v-if="prevNews" :href="prevNews.link ? prevNews.link + '?id=' +prevNews.id : 'javascript:void(0)'" class="page_column_part d-flex flex-column" :class="{disabled: !prevNews.link}">
                <div class="news_area">
                    <p class="news_text fw-bold" v-html="prevNews.title"></p>
                </div>
                <div class="mt-auto news_area_bottom">
                    <ul class="news_list d-flex align-items-center" v-if="prevNews.categories">
                        <li :class="`${prevNews.categories}`" v-html="`${prevNews.categories}`"></li>
                    </ul>
                    <p class="news_button">Prev</p>
                </div>
            </a>
            <a v-else href="javascript:void(0)" class="page_column_part d-flex flex-column disabled" >
                <div class="news_area">
                    <p class="news_text fw-bold" ></p>
                </div>
                <div class="mt-auto news_area_bottom">
                    <ul class="news_list d-flex align-items-center">
                    </ul>
                    <p class="news_button">Prev</p>
                </div>
            </a>
            <a v-if="nextNews" :href="nextNews.link ? nextNews.link + '?id=' +nextNews.id : 'javascript:void(0)'" class="page_column_part d-flex flex-column" :class="{disabled: !nextNews.link}">
                <div class="news_area">
                    <p class="news_text fw-bold" v-html="nextNews.title"></p>
                </div>
                <div class="mt-auto news_area_bottom">
                    <ul class="news_list d-flex align-items-center justify-content-end" v-if="nextNews.categories">
                        <li :class="`${nextNews.categories}`" v-html="`${nextNews.categories}`"></li>
                    </ul>
                    <p class="news_button">Next</p>
                </div>
            </a>
            <a v-else href="javascript:void(0)" class="page_column_part d-flex flex-column disabled">
                <div class="news_area">
                    <p class="news_text fw-bold"></p>
                </div>
                <div class="mt-auto news_area_bottom">
                    <ul class="news_list d-flex align-items-center justify-content-end">
                        
                    </ul>
                    <p class="news_button">Next</p>
                </div>
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'NewsBottom',
        props: {
            prevNews: Object,
            nextNews: Object
        }
    }
</script>

<style lang="scss" scoped>
    .news_list {
        margin-bottom: 25px;
        padding-left: 0;

        > li {
            list-style: none;
            position: relative;

            &:first-child {
                padding-left: 40px;

                &::before {
                    content: '';
                    display: block;
                    width: 20px;
                    height: 12px;
                    background: url('../../assets/news/flag/japan-flag.svg') no-repeat center center;
                    background-size: cover;
                    position: absolute;
                    top: 6px;
                    left: 0;
                }
            }

            &.Vietnam::before {
                background: url('../../assets/news/flag/vienna-flag.svg') no-repeat center center;
                background-size: cover;
            }

            &.China::before {
                background: url('../../assets/news/flag/chinese-flag.svg') no-repeat center center;
                background-size: cover;
            }

            &.Taiwan::before {
                background: url('../../assets/news/flag/taiwan-flag.svg') no-repeat center center;
                background-size: cover;
            }

            &.Thailand::before {
                background: url('../../assets/news/flag/thailand-flag.svg') no-repeat center center;
                background-size: cover;
            }

            &.Malaysia::before {
                background: url('../../assets/news/flag/malaysia-flag.svg') no-repeat center center;
                background-size: cover;
            }

            &:not(:last-child) {
                padding-right: 18px;
                margin-right: 17px;

                &::after {
                    content: '';
                    display: block;
                    height: 16px;
                    border-right: 2px solid #000000;
                    position: absolute;
                    top: calc(50% - 8px);
                    right: 0;
                }
            }
        }
    }

    .page_column {
        background-color: #f8f8f8;
        padding: 61px 0 50px 0;

        .container {
            justify-content: space-between;
        }

        .news_list {
            font-size: 14px;
        }

        .news_list > li:first-child {
            padding-left: 31px;
        }

        .news_list > li:not(:last-child)::after {
            border-right: 1px solid #000000;
        }
    }

    .page_column_part {
        transition: all 0.3s;
    }

    .news_button {
        transition: all 0.3s;
    }

    .page_column_part {
        &.disabled {
            pointer-events: none;
            .news_button {
                color: #999999;
                border-top: 1px solid #999999;
            }
        }
        .news_button {
            position: relative;
            &::before {
                opacity: 0;
                content: '';
                display: block;
                width: 20px;
                height: 20px;
                border-top: 1px solid #f2aa00;
                transform: rotate(-45deg);
                position: absolute;
                left: 30%;
                top: -11px;
                transition: left .25s ease;
            }
        }
    }

    .page_column_part:not(.disabled):hover {
        color: #000000;

        .news_button {
            border-top: 1px solid #f2aa00;
            padding-left: 10px;
            &::before {
                opacity: 1;
                left: 4px;
            }
        }
    }

    .page_column_part:first-child {
        width: 48.4%;
        .news_button {
            min-height: 69.8px;
        }
    }

    .page_column_part:nth-child(2) {
        width: 23.6%;
    }

    .page_column_part:last-child {
        width: 23.6%;

        .news_button {
            text-align: right;
            &::before {
                right: 30%;
                left: unset;
                transform: rotate(45deg);
                transition: right .25s ease;
            }
        }

        &:hover:not(.disabled) .news_button {
            padding-right: 10px;
            &::before {
                right: 4px;
                left: unset;
            }
        }
    }

    .news_text {
        font-size: 14px;
    }

    .news_area_bottom {
        .news_button {
            padding-top: 35px;
            border-top: 1px solid #000000;
        }
    }

    .news_button {
        font-weight: 500;
        font-size: 20px;
    }

    @media screen and (max-width: 767px) {
        .page_column_part:nth-child(2) {
            width: 45.8%;
        }

        .page_column_part:last-child {
            width: 45.8%;
        }

        .back {
            position: relative;
        }

        .page_column_part:active,.page_column_part:hover {
            .news_button {
                transition: unset;
                &::before {
                    transition: unset;
                }
            }
        }

        .page_column_part:last-child:active, .page_column_part:last-child:hover {
            .news_button {
                transition: unset;
                &::before {
                    transition: unset;
                }
            }
        }
    }
</style>
